import { I_playfair } from './StyleConstants';

export { ALLOWED_RARE_COUNTRIES } from './allowedCountries';

export const SOPHISTICATION_CONTENT = {
  head: (
    <>
      UNB<I_playfair>O</I_playfair>X<br />S<I_playfair>O</I_playfair>
      PHISTICATI<I_playfair>O</I_playfair>N
    </>
  ),
  items: [
    {
      colA: `[A]`,
      colB: `Unparalleled Accuracy`,
      colC: `Precisely track advanced biomarkers such as Sleep, Stress, Movement,
            Heart Rate (HR), Heart Rate Variability (HRV), and Skin Temperature.
            Unlock unparalleled accuracy and insights into your health and
            performance.`,
    },
    {
      colA: `[B]`,
      colB: `Cutting Edge Health Technology`,
      colC: `Rare is built on top of Ultrahuman's core cutting-edge technology, including advanced 6-axis motion sensors, skin temperature sensors and photoplethysmography (PPG) sensors.`,
    },
    {
      colA: `[C]`,
      colB: {
        head: 'Lifetime UltrahumanX Access',
        desc: 'Gain lifetime access to UltrahumanX, a special coverage and benefits program.',
      },
      colC: {
        head: 'PowerPlugs Access',
        desc: 'Enjoy complimentary access to all current and future PowerPlugs, allowing you the versatility of customizing the Ultrahuman experience to your health goals.',
      },
    },
  ],
};

export const BENEFITS_CONTENT = {
  head: <>UltrahumanX Membership</>,
  image: true,
  noMargin: true,
  items: [
    {
      colA: `[A]`,
      colB: `Complimentary Membership`,
      colC: `Ultrahuman Rare users get complimentary lifetime access to UltrahumanX.`,
    },
    {
      colA: `[B]`,
      colB: `Lifetime Priority Support*`,
      colC: `With Rare, access lifetime priority assistance from Ultrahuman's support team for any inquiries, guidance, or clarifications related to your Rare Ring.`,
    },
    {
      colA: `[C]`,
      colB: `Lifetime Access to PowerPlugs*`,
      colC: `Unlock lifetime complimentary access to all free and paid PowerPlugs, including existing and future releases, ensuring you always have the latest features and updates.`,
    },
    {
      colA: `[D]`,
      colB: `Size Protection`,
      colC: `Ultrahuman Rare users are eligible for size protection: a one-time complimentary size adjustment within one year of purchase. Simply reach out to Ultrahuman’s support team to initiate the process.`,
    },
    {
      colA: `[E]`,
      colB: `Upgrade Program`,
      colC: (
        <>
          Access upgrades to newer collections with a dedicated upgrade program
          designed exclusively for Rare ring users.
          <br />
          <br />
          This program allows you to swap your Rare ring and upgrade to new
          Ultrahuman collections or those featuring enhanced electronics*
        </>
      ),
    },
    {
      colA: `[F]`,
      colB: `Lifetime Replacement Coverage*`,
      colC: `Ultrahuman will repair or replace Rare rings for any defects that are manufacturing related, throughout its lifetime. `,
    },
    {
      colA: null,
      colB: `*Subject to Ultrahuman's Policy and Terms of Use`,
      colC: (
        <>
          Please reach out to Ultrahuman&apos;s support at
          rare-support@ultrahuman.com for any questions or clarifications.
        </>
      ),
    },
  ],
};
